import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconBurgerMenu = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.75 5.41675H16.25M3.75 10.0001H10.25M3.75 14.5834H14.25"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconBurgerMenu.displayName = "IconBurgerMenu";

export { IconBurgerMenu };
